var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205 42",
    style: {
      enableBackground: "new 0 0 205 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#1957E8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M29.9,16.7l-2.5,2.7l-2.7-2.6l-2.6,2.7l-2.9-2.7l5.1-5.4l-5.8-5.5l-13,13.8l5.8,5.5l2.5-2.6 l2.9,2.7l-5,5.3l2.7,2.6l0,0l-5.2-4.9l-0.5-0.4L6,25.3l-6-5.6L15.6,3.2l-2.7-2.6L29.6,0L29.9,16.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    className: "st1",
    d: "M20.3,38.8l2.7,2.6L6.3,42L6,25.3l3.2,3l-0.5-0.4l2.5-2.6l0.1-0.1l2.5-2.6l2.9,2.7l-5,5.3 l2.7,2.6l3.1,2.9l13-13.8l-3.1-2.9l-2.7-2.6l2.6-2.7l2.7,2.6l6,5.6L20.3,38.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.3,11.9v12.8c0,4.7-2.9,8.7-8.7,8.7c-5.8,0-8.7-3.9-8.7-8.7V11.9H49v12.8c0,2.3,1.2,3.9,3.6,3.9 c2.4,0,3.6-1.6,3.6-3.9V11.9H61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.8,22.8V33h-5.1v-9.2c0-1.7-1.2-2.7-2.7-2.7c-1.5,0-2.8,1.1-2.8,2.6V33h-5.1V17h4.8v1.3 c1.1-1,2.7-1.7,4.6-1.7C77.3,16.6,79.8,19.1,79.8,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,11.7c0-1.8,1.4-3.1,3.2-3.1c1.8,0,3.2,1.3,3.2,3.1s-1.4,3.1-3.2,3.1C83.3,14.8,81.9,13.6,81.9,11.7z  M82.5,17h5.1v16h-5.1V17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.1,26.8v-5.5h-2.7V17h1.3c1.1,0,1.7-0.6,1.7-1.8v-2.5h4.9V17h3.6v4.3h-3.8v4.9c0,1.5,0.8,2.4,2.2,2.4h1.7 V33h-2.7C94.2,33,92.1,30.5,92.1,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.8,29.3c1.8,0,2.7-0.6,3.3-1.7l3.8,2.5c-1.3,1.7-3.3,3.3-7.3,3.3c-5.3,0-8.6-3.6-8.6-8.4 c0-4.6,3.7-8.4,8.3-8.4c5.2,0,8.3,4.1,8.3,8.1c0,0.8-0.1,1.4-0.1,1.8h-11.6C107.5,28.3,108.9,29.3,110.8,29.3z M114,23.3 c-0.4-1.8-1.6-2.9-3.5-2.9s-3.2,1-3.6,2.9H114z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.4,10.8V33h-4.7v-1.4c-1.2,1.1-2.7,1.8-4.6,1.8c-4.6,0-8-3.6-8-8.4c0-4.8,3.2-8.4,7.9-8.4 c1.7,0,3.2,0.5,4.3,1.5v-7.3H137.4z M132.6,25c0-2.3-1.5-4-3.7-4c-2.1,0-3.7,1.7-3.7,4s1.5,3.9,3.7,3.9 C131.1,28.9,132.6,27.3,132.6,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.8,28.5V33h-14.5V11.9h5.1v16.6H160.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162,11.7c0-1.8,1.4-3.1,3.2-3.1c1.8,0,3.2,1.3,3.2,3.1s-1.4,3.1-3.2,3.1C163.4,14.8,162,13.6,162,11.7z  M162.6,17h5.1v16h-5.1V17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.2,22.8V33h-5.1v-9.2c0-1.7-1.2-2.7-2.7-2.7c-1.5,0-2.8,1.1-2.8,2.6V33h-5.1V17h4.8v1.3 c1.1-1,2.7-1.7,4.6-1.7C183.8,16.6,186.2,19.1,186.2,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.2,33l-5.1-7v7H189V10.8h5.1v12.3L199,17h5.6l-6,7.4l6,8.6H199.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.e7afc9481a8497585a641e3c347f2c86.svg";
export { ForwardRef as ReactComponent };